import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  CREATE_SETTINGS,
  DELETE_SETTINGS,
  EDIT_SETTINGS,
  LOAD_SETTING_BY_ID,
  LOAD_SETTINGS,
} from './actions';

import {
  createLoadListReducerWithBegin,
  createLoadParameterReducer,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import { SETTINGS_MODULE } from '../../configs/moduleNames';

const initialState = {
  loadingCreateSettings: false,
  loadingDeleteSettings: false,
  loadingSettingsList: false,
  loadingEditSettings: false,
  loadingCurrentSettings: false,
  currentSettings: {},
  settingsList: [],
  settingsListMeta: {},
};

const reducer = handleActions({
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE_SETTINGS, 'loadingCreateSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_SETTINGS, 'loadingDeleteSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + EDIT_SETTINGS, 'loadingEditSettings'),
  ...createLoadListReducerWithBegin(SETTINGS_MODULE + LOAD_SETTINGS, 'settingsList', 'loadingSettingsList'),
  ...createLoadParameterReducer(SETTINGS_MODULE + LOAD_SETTING_BY_ID, 'currentSettings', 'loadingCurrentSettings'),
}, initialState);

export default reducer;

export const getSettingsData = createSelector(
  [state => state[SETTINGS_MODULE]],
  state => {
    const {
      loadingCreateSettings,
      loadingDeleteSettings,
      loadingSettingsList,
      loadingEditSettings,
      loadingCurrentSettings,
      currentSettings,
      settingsList,
      settingsListMeta,
    } = state;
    return {
      loadingCreateSettings,
      loadingDeleteSettings,
      loadingSettingsList,
      loadingEditSettings,
      loadingCurrentSettings,
      currentSettings,
      settingsList,
      settingsListMeta,
    };
  },
);
